/**
 * How many to order up to the maximum. Spec 014, FR-1410 and FR-1411.
 *
 * Guy, 29 October 2026 (Part 2.1): a minimum and a maximum. The minimum is the
 * reorder point, which decides WHEN an item is short. The maximum decides HOW
 * MANY: enough to bring free stock plus what is already on order up to it.
 *
 *   max_level - (free + on order), never less than zero
 *
 * Free is on hand less reserved, summed across every location. Null when the
 * item has no maximum: the caller then orders as it did before, by the reorder
 * quantity. One function, so the Reorder screen, its "Raise" button and the
 * buy-everything draft cannot work it out three ways. It suggests; a person
 * sends the order.
 */
export function orderUpTo(
  item: { max_level?: number | string | null },
  free: number,
  onOrder: number,
): number | null {
  if (item.max_level == null || item.max_level === '') return null;
  const max = Number(item.max_level);
  if (!Number.isFinite(max)) return null;
  return Math.max(0, max - (free + onOrder));
}

/**
 * What the Reorder screen's Order column and its "Raise" button order. The
 * server works it out (`suggested_qty`, from `orderUpTo`); an older answer
 * without it falls back to the reorder quantity, as before.
 */
export function suggestedQty(row: { suggested_qty?: number | null; reorder_qty?: number | null }): number {
  if (row.suggested_qty !== undefined) return Number(row.suggested_qty ?? 0);
  return Number(row.reorder_qty ?? 0);
}
